/**
 * 上传笔记页 Mock 数据
 * 5 步流程：1上传文件 2生成大纲 3选择题目 4生成正文 5笔记本
 */

export const MOCK_SOURCES = [
  { id: 'mock-1', type: 'markdown', name: 'functions.md', file: null },
  { id: 'mock-2', type: 'markdown', name: 'relations.md', file: null },
  { id: 'mock-3', type: 'markdown', name: 'linkedList.md', file: null },
]

export const MOCK_OUTLINE = [
  { title: '基本定义与示例', description: '函数、定义域、陪域与值域的基本概念与简单例子。', order: 1, marker: '头15字|尾15字', source_content: '**函数**：设 $A,B$ 为非空集合，若存在规则 $f$ 使对每个 $x\\in A$ 有唯一 $y\\in B$ 与之对应，则称 $f$ 为从 $A$ 到 $B$ 的函数，记作 $f:A\\to B$。\n\n示例：$f(x)=x^2$ 是 $\\mathbb{R}\\to\\mathbb{R}$ 的函数。' },
  { title: '判定为函数的条件与直观测试', description: '如何判断一个对应关系是否为函数。', order: 2, marker: '判定为函数|直观测试。', source_content: '判定为函数的条件：对定义域中每个元素，必须有且仅有一个像。' },
  { title: '函数图像与一一性、满射性判定', description: '从图像判断单射、满射的直观方法。', order: 3, marker: '函数图像|满射性判定。', source_content: '**函数图像**：满足 $y=f(x)$ 的点集。**一一性（单射）**：水平线最多与图像交于一点。' },
  { title: '注入/满射/双射的证明技巧与例题', description: '如何用定义或逆映射证明单射、满射与双射。', order: 4, marker: '证明技巧|例题。', source_content: '**单射证明**：设 $f(x_1)=f(x_2)$，推出 $x_1=x_2$。**满射证明**：对任意 $b\\in B$，存在 $a\\in A$ 使 $f(a)=b$。' },
  { title: '链表的结点与指针', description: '结点结构、指针域与头指针。', order: 5, marker: '结点|头指针。', source_content: '**结点**：通常包含数据域与指针域（next）。**单链表**：每个结点指向下一个。' },
]

const MOCK_SECTION = (title, intro, def) => ({
  section_title: title,
  introduction: intro,
  concept_blocks: [{ definition: def, examples: [], notes: [], theorems: [] }],
  standalone_examples: [],
  standalone_notes: [],
  summary: '',
  exercises: [],
})

export const MOCK_SECTIONS = [
  MOCK_SECTION('基本定义与示例', '本章介绍函数的基本概念。', '**函数**：设 $A,B$ 为非空集合，若存在规则 $f$ 使对每个 $x\\in A$ 有唯一 $y\\in B$ 与之对应，则称 $f$ 为从 $A$ 到 $B$ 的函数。'),
  MOCK_SECTION('判定为函数的条件与直观测试', '如何判断一个对应关系是否为函数。', '对定义域中每个元素，必须有且仅有一个像。一多对应、无定义点均不构成函数。'),
  MOCK_SECTION('函数图像与一一性、满射性判定', '从图像判断单射、满射的直观方法。', '**函数图像**：满足 $y=f(x)$ 的点集。**一一性（单射）**：水平线最多与图像交于一点。'),
  MOCK_SECTION('注入/满射/双射的证明技巧与例题', '如何用定义或逆映射证明单射、满射与双射。', '**单射证明**：设 $f(x_1)=f(x_2)$，推出 $x_1=x_2$。**满射证明**：对任意 $b\\in B$，存在 $a\\in A$ 使 $f(a)=b$。'),
  MOCK_SECTION('链表的结点与指针', '结点结构、指针域与头指针。', '**结点**：通常包含数据域与指针域（next）。**单链表**：每个结点指向下一个，最后一个指向 null。'),
]

// 步骤 1：上传文件
export const MOCK_MESSAGES_STEP1 = []

// 步骤 2：生成大纲
export const MOCK_MESSAGES_STEP2 = [
  { id: 'm1', type: 'user', content: '上传 functions.md、relations.md 和 linkedList.md' },
  { id: 'm2', type: 'system', content: '正在上传文件: functions.md' },
  { id: 'm3', type: 'system', content: '正在上传文件: relations.md' },
  { id: 'm4', type: 'system', content: '正在上传文件: linkedList.md' },
  { id: 'm5', type: 'system', content: '正在转换文件，这可能需要几分钟时间，请耐心等待...' },
  { id: 'm6', type: 'system', content: '已解析 3 个 Markdown 文件，共 1247 行。' },
  { id: 'm7', type: 'system', content: '📝 正在生成笔记大纲...' },
  { id: 'm8', type: 'system', content: '正在分析文档结构与知识点分布...' },
  { id: 'm9', type: 'system', content: '已识别 12 个潜在章节标题与 38 处关键概念。' },
  { id: 'm10', type: 'system', content: '✓ 大纲生成完成！请点击左侧大纲章节预览，确认后点击「确认大纲」。' },
]

// 步骤 3：选择题目（与步骤 2 消息相同，大纲已就绪）
export const MOCK_MESSAGES_STEP3 = MOCK_MESSAGES_STEP2

// 步骤 4：生成正文进度
export const MOCK_MESSAGES_STEP4 = [
  ...MOCK_MESSAGES_STEP2,
  { id: 'm11', type: 'system', content: '正在生成章节内容，这可能需要几分钟时间，请耐心等待...' },
]

// 步骤 5：笔记本（完整消息）
export const MOCK_MESSAGES_STEP5 = [
  ...MOCK_MESSAGES_STEP4,
  { id: 'm12', type: 'system', content: '✓ 笔记本已经写好了！请查看右侧预览。' },
]

export const MOCK_NOTEBOOK_DATA_OUTLINE_ONLY = {
  description: '函数与映射、关系与等价类、链表：基本定义与对比',
  outline: MOCK_OUTLINE,
  sections: [],
  notebookId: 'mock-notebook-1',
  originalFilePath: '/tmp/functions.md',
  fullOutline: {
    notebook_title: '函数、关系与链表',
    notebook_description: '函数与映射、关系与等价类、链表：基本定义与对比',
    outlines: Object.fromEntries(MOCK_OUTLINE.map((o) => [o.title, o.description])),
    section_markers: {},
    section_source_content: Object.fromEntries(MOCK_OUTLINE.map((o) => [o.title, o.source_content || ''])),
  },
}

export const MOCK_NOTEBOOK_DATA_FULL = {
  ...MOCK_NOTEBOOK_DATA_OUTLINE_ONLY,
  sections: MOCK_SECTIONS,
}

export const MOCK_GENERATION_PROGRESS_OUTLINE = {
  stage: 'outline_completed',
  timestamp: Date.now() / 1000,
  data: { message: '大纲生成完成' },
}

export const MOCK_GENERATION_PROGRESS_SECTIONS = {
  stage: 'generating_sections',
  timestamp: Date.now() / 1000,
  data: {
    message: '正在生成章节内容...',
    logs: [
      '[1/5] 正在创建章节: 基本定义与示例',
      '[1/5] ✓ 章节 \'基本定义与示例\' 创建完成',
      '[2/5] 正在创建章节: 判定为函数的条件与直观测试',
      '[2/5] ✓ 章节 \'判定为函数的条件与直观测试\' 创建完成',
      '[3/5] 正在创建章节: 函数图像与一一性、满射性判定',
      '[3/5] ✓ 章节 \'函数图像与一一性、满射性判定\' 创建完成',
      '[4/5] 正在创建章节: 注入/满射/双射的证明技巧与例题',
      '[4/5] 使用 section_markers 提取章节内容',
    ],
  },
}

export const MOCK_GENERATION_PROGRESS_COMPLETED = {
  stage: 'sections_completed',
  timestamp: Date.now() / 1000,
  data: { message: '章节生成完成', notebookReady: true },
}

/** 步骤 1：上传文件（仅有源文件） */
export function getMockStateStep1() {
  return {
    sources: MOCK_SOURCES,
    messages: MOCK_MESSAGES_STEP1,
    notebookData: null,
    generationProgress: null,
    selectedCourseCode: 'MATH101',
    uploadProgress: 0,
    isUploading: false,
  }
}

/** 步骤 2：生成大纲（有大纲、无章节） */
export function getMockStateStep2() {
  return {
    sources: MOCK_SOURCES,
    messages: MOCK_MESSAGES_STEP2,
    notebookData: MOCK_NOTEBOOK_DATA_OUTLINE_ONLY,
    generationProgress: MOCK_GENERATION_PROGRESS_OUTLINE,
    selectedCourseCode: 'MATH101',
    uploadProgress: 100,
    isUploading: false,
  }
}

/** 步骤 3：选择题目（大纲待确认） */
export function getMockStateStep3() {
  return getMockStateStep2()
}

/** 步骤 4：生成正文进度 */
export function getMockStateStep4() {
  return {
    sources: MOCK_SOURCES,
    messages: MOCK_MESSAGES_STEP4,
    notebookData: MOCK_NOTEBOOK_DATA_OUTLINE_ONLY,
    generationProgress: MOCK_GENERATION_PROGRESS_SECTIONS,
    selectedCourseCode: 'MATH101',
    uploadProgress: 100,
    isUploading: true,
  }
}

/** 步骤 5：笔记本（章节已完成） */
export function getMockStateStep5() {
  return {
    sources: MOCK_SOURCES,
    messages: MOCK_MESSAGES_STEP5,
    notebookData: MOCK_NOTEBOOK_DATA_FULL,
    generationProgress: MOCK_GENERATION_PROGRESS_COMPLETED,
    selectedCourseCode: 'MATH101',
    uploadProgress: 100,
    isUploading: false,
  }
}

/** 兼容旧版：完整 mock（步骤 5） */
export function getMockState() {
  return getMockStateStep5()
}

/** 兼容旧版：大纲待确认（步骤 2/3） */
export function getMockStateOutlineReady() {
  return getMockStateStep2()
}
